import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function makeInlineToolbarButton(id, options) {
  return {
    inlineToolbarButton: function inlineToolbarButton() {
      if (options instanceof Function) {
        return options(); // {id , ... options} || Array<{id, ...options}>
      }

      return _objectSpread({
        id: id
      }, options);
    },
    toolbarButton: function toolbarButton() {
      if (options instanceof Function) {
        return options();
      }

      var _options$title = options.title,
          title = _options$title === void 0 ? '' : _options$title,
          _options$alias = options.alias,
          alias = _options$alias === void 0 ? [] : _options$alias;
      return _objectSpread({
        id: id
      }, options, {
        searchTerms: [].concat(_toConsumableArray(alias), [title.toLowerCase()])
      });
    }
  };
}

export default makeInlineToolbarButton;